<template>
    <div>
        <div class="mb-24">
            <p class="text-body font-semibold mb-8">{{ $t('general.jobs.title') }}</p>
            <div class="space-y-12">
                <date-picker
                    v-model="filterFields.dateFromJobs"
                    :future-limit="today"
                    :past-limit="pastLimit"
                    :input-label="$t('general.from')"
                />
                <date-picker
                    v-model="filterFields.dateToJobs"
                    :future-limit="today"
                    :past-limit="pastLimit"
                    :input-label="$t('general.to')"
                />
            </div>
        </div>
        <div class="mb-24">
            <p class="text-body font-semibold mb-8">{{ $t('general.applications.title') }}</p>
            <div class="space-y-12">
                <date-picker
                    v-model="filterFields.dateFromApplications"
                    :future-limit="today"
                    :past-limit="pastLimit"
                    :input-label="$t('general.from')"
                />
                <date-picker
                    v-model="filterFields.dateToApplications"
                    :future-limit="today"
                    :past-limit="pastLimit"
                    :input-label="$t('general.to')"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from '../forms/DatePicker.vue';
import {extendMoment} from "moment-range";
import Moment from "moment";
import {mapState} from "pinia";
import {useAnalyticsStore} from '../../state/modules/analytics';
import AnalyticsMixins from "../../mixins/analyticsMixins";

const moment = extendMoment(Moment)

export default {
    name: 'FilterDate',
    components: {
        DatePicker,
    },
    props: {
        filterFields: Object,
        limit: Number,
    },
    mixins: [AnalyticsMixins],
    computed: {
        ...mapState(useAnalyticsStore, ['getCompanyCreatedAt']),
        today() {
            return moment();
        },
        pastLimit() {
            return moment(this.getCompanyCreatedAt);
        },
    },
    methods: {
        jobDateDiff() {
            if (this.filterFields.dateFromJobs && this.filterFields.dateToJobs) {
                return this.filterFields.dateToJobs.diff(this.filterFields.dateFromJobs, 'years');
            } else return 0;
        },
        applicationDateDiff() {
            if (this.filterFields.dateFromApplications && this.filterFields.dateToApplications) {
                return this.filterFields.dateToApplications.diff(this.filterFields.dateFromApplications, 'years');
            } else return 0;
        },
    },
}
</script>
